import firebase from "../../firebase";

export default function({ officeId, stages }) {
    return firebase.functions().httpsCallable("allFunctions")({
        funcRole: "patientTrackingAdmin",
        funcName: "addStagesToOffice",
        data: { officeId, stages }
    });
}
